// src/data.js
import {
  Layers,
  Armchair,
  Sofa,
  Scroll,
  Palette,
  Square,
  Shirt,
} from "lucide-react";

export const PRODUCT_CONFIG = {
  dust_mite: { label: "除塵墊", icon: Layers, db: null },
  sofa_mat: { label: "沙發墊", icon: Armchair, db: "sofa_styles" },
  cushion: { label: "坐墊", icon: Sofa, db: null },
  carpet: { label: "地毯", icon: Scroll, db: "carpet_styles" },
  edging_carpet: {
    label: "壓邊地毯",
    icon: Palette,
    db: "edging_carpet_styles",
  },
  wall_sticker: { label: "防撞壁貼", icon: Square, db: "wall_sticker_styles" },
  apron: { label: "圍裙", icon: Shirt, db: "apron_styles" },
};

export const APRON_CATEGORIES = ["圍裙", "帽子", "POLO工作服"];

// ── 沙發墊部位 ──
// 客人提供的尺寸（深度／寬度／高度）依各部位公式換算為「實際應製作尺寸」，
// 報價即以換算後的尺寸計算。needsHeight 為 true 者需額外填寫高度。
export const SOFA_AREA_TYPES = [
  { value: "armrest",        label: "扶手區",          needsHeight: true,  needsDepth: true  },
  { value: "seat",           label: "坐墊區",          needsHeight: false, needsDepth: true  },
  { value: "chaise_double",  label: "貴妃區雙邊下垂",  needsHeight: false, needsDepth: true  },
  { value: "chaise_single",  label: "貴妃區單邊下垂",  needsHeight: false, needsDepth: true  },
  { value: "backrest",       label: "靠背區",          needsHeight: false, needsDepth: false },
  { value: "free",           label: "自由設定",        needsHeight: false, needsDepth: true  },
];

// 修正：移除皮標壓印，修改顯示文字
export const LOGO_PROCESSING_OPTIONS = [
  { label: "熱轉印(+$58)", value: "heat_transfer", cost: 58, setup: 300 },
  { label: "刺繡(+$98)", value: "embroidery", cost: 98, setup: 500 },
];

export const CUSHION_OPTIONS = [
  { label: "A款", value: "A", fee: 0 },
  { label: "B款 (加+10)", value: "B", fee: 10 },
  { label: "C款 (加+10)", value: "C", fee: 10 },
  { label: "D款 (加+10)", value: "D", fee: 10 },
];

export const SOURCE_OPTIONS = ["Line", "FB", "網店"];

export const EDGING_CARPET_WIDTHS = [
  { keyword: "鑽石", widths: [120, 160] },
  { keyword: "波蘿", widths: [120, 160, 200] },
  { keyword: "尼龍", widths: [180] },
];
export const EDGING_CARPET_PRINT_WIDTHS = [
  { keyword: "鑽石印刷", widths: [120] },
  { keyword: "波蘿印刷", widths: [200] },
  { keyword: "尼龍印刷", widths: [200] },
];
export const CARPET_WIDTH_CONFIGS = [
  {
    names: ["圓絨滴膠底", "圓絨矽膠棉布底", "仿羊絨滴膠底", "仿羊絨矽膠棉布底", "細棉絨矽膠棉布底"],
    widths: [160, 200, 240, 300],
  },
];

export const DEFAULT_APRON_STYLES = [
  { name: "職人工作圍裙", category: "圍裙", cost: 480 },
  { name: "職人加厚耐磨圍裙", category: "圍裙", cost: 790 },
  { name: "西服執事圍裙", category: "圍裙", cost: 580 },
  { name: "職人防水防油圍裙", category: "圍裙", cost: 480 },
  { name: "韓版帆布圍裙", category: "圍裙", cost: 580 },
  { name: "職人牛仔布圍裙", category: "圍裙", cost: 480 },
  { name: "造型師職人圍裙", category: "圍裙", cost: 600 },
  { name: "職人仿皮革防水圍裙", category: "圍裙", cost: 480 },
  { name: "技師加厚耐磨圍裙", category: "圍裙", cost: 790 },
  { name: "職人皮背帶雙色圍裙", category: "圍裙", cost: 990 },
  { name: "輕量化工作圍裙", category: "圍裙", cost: 330 },
  { name: "咖啡茶飲職人圍裙", category: "圍裙", cost: 600 },
  { name: "職人多用途圍裙", category: "圍裙", cost: 600 },
  { name: "仿皮革多口袋圍裙", category: "圍裙", cost: 600 },
  { name: "職人廚務半身圍裙", category: "圍裙", cost: 480 },
  { name: "混搭皮革職人圍裙", category: "圍裙", cost: 600 },
  { name: "拼接撞色職人圍裙", category: "圍裙", cost: 690 },
  { name: "餐酒館職人半身圍裙", category: "圍裙", cost: 480 },
  { name: "職人水洗帆布圍裙", category: "圍裙", cost: 530 },
  { name: "斜角雙拼職人文青圍裙", category: "圍裙", cost: 580 },
  { name: "職人輕量帆布圍裙", category: "圍裙", cost: 400 },
  { name: "水洗牛仔布職人圍裙(牛仔背帶)", category: "圍裙", cost: 790 },
  { name: "水洗牛仔布職人圍裙(皮革背帶)", category: "圍裙", cost: 950 },
  { name: "半身職人輕帆布圍裙", category: "圍裙", cost: 480 },
  { name: "仕女摺邊工作圍裙", category: "圍裙", cost: 600 },
  { name: "多用途技術士圍裙", category: "圍裙", cost: 580 },
  { name: "多用途皮革厚磅職人圍裙", category: "圍裙", cost: 730 },
  { name: "西式輕帆布甜品店圍裙", category: "圍裙", cost: 580 },
  { name: "匠人多口袋厚磅帆布圍裙(布織背帶)", category: "圍裙", cost: 720 },
  { name: "匠人多口袋厚磅帆布圍裙(皮革背帶)", category: "圍裙", cost: 1060 },
  { name: "韓式半身帆布皮革圍裙", category: "圍裙", cost: 550 },
  { name: "餐廚達人皮革背帶帆布圍裙", category: "圍裙", cost: 480 },
  { name: "韓式餐飲廚務吊環圍裙", category: "圍裙", cost: 705 },
  { name: "饗宴餐飲厚磅拼接皮革圍裙", category: "圍裙", cost: 725 },
  { name: "前後包覆文青吊帶圍裙", category: "圍裙", cost: 450 },
  { name: "韓系咖啡點心店工作圍裙", category: "圍裙", cost: 795 },
  { name: "美式拉鍊帆布圍裙", category: "圍裙", cost: 580 },
  { name: "韓風俐落加厚技師圍裙", category: "圍裙", cost: 480 },
  { name: "手作坊牛仔皮革背帶圍裙", category: "圍裙", cost: 520 },
  { name: "工業風匠人耐磨防水圍裙", category: "圍裙", cost: 730 },
  { name: "開衩皮革拉鍊防水防油圍裙", category: "圍裙", cost: 520 },
  { name: "技工厚帆布短版可客製圍裙", category: "圍裙", cost: 850 },
  { name: "大口袋牛津布防水圍裙", category: "圍裙", cost: 550 },
  { name: "拚色簡約韓系掛脖圍裙", category: "圍裙", cost: 390 },
  { name: "條紋簡約掛脖圍裙", category: "圍裙", cost: 600 },
  { name: "半身水洗牛仔圍裙", category: "圍裙", cost: 790 },
  { name: "多口袋營業用帆布圍裙", category: "圍裙", cost: 820 },
  { name: "掛脖可調節職人圍裙", category: "圍裙", cost: 350 },
  { name: "隱式口袋帆布圍裙", category: "圍裙", cost: 690 },
  { name: "寬背帶原色感圍裙", category: "圍裙", cost: 420 },
  { name: "背扣水洗牛仔布圍裙", category: "圍裙", cost: 790 },
  { name: "淬鍊職人防水圍裙", category: "圍裙", cost: 330 },
  { name: "森系棉麻純色圍裙", category: "圍裙", cost: 480 },
  { name: "貝雷帽A款", category: "帽子", cost: 140 },
  { name: "貝雷帽B款", category: "帽子", cost: 160 },
  { name: "鴨舌帽", category: "帽子", cost: 120 },
];

export const DEFAULT_SOFA_STYLES = [
  { name: "仿兔毛柔軟加厚沙發墊",           cost: 100, freightRate: 8 },
  { name: "舒柔保暖羊羔絨沙發墊",           cost: 65,  freightRate: 8 },
  { name: "山嵐幾何形涼感沙發墊",           cost: 65,  freightRate: 8 },
  { name: "夏意沁涼織紋沙發墊",             cost: 70,  freightRate: 8 },
  { name: "抱枕套",                         cost: 120, freightRate: 8 },
  { name: "格林紋科技布沙發墊",             cost: 60,  freightRate: 8 },
  { name: "仿牛皮紋防水耐刮沙發墊",         cost: 60,  freightRate: 8 },
  { name: "華夫格防水四季用沙發墊",         cost: 60,  freightRate: 8 },
  { name: "星耀涼感舒適沙發墊",             cost: 60,  freightRate: 8 },
  { name: "日本棉麻編織沙發墊",             cost: 60,  freightRate: 8 },
  { name: "北歐星星四季用沙發墊",           cost: 60,  freightRate: 8 },
  { name: "和風棉麻花紋四季用沙發墊",       cost: 60,  freightRate: 8 },
  { name: "玄紋雪尼爾耐貓抓沙發墊",         cost: 60,  freightRate: 8 },
  { name: "涼感柳蔓細語沙發墊",             cost: 60,  freightRate: 8 },
  { name: "燈心絨耐磨防水四季用沙發墊",     cost: 60,  freightRate: 8 },
  { name: "冰絲夏語涼感沙發墊",             cost: 60,  freightRate: 8 },
  { name: "冰藤涼蓆沙發墊",                 cost: 60,  freightRate: 8 },
  { name: "歐系葉語四季用雪尼爾沙發墊",     cost: 60,  freightRate: 8 },
  { name: "雲絨浮花繪沙發墊",               cost: 60,  freightRate: 8 },
  { name: "暖心舒眠絨沙發墊",               cost: 60,  freightRate: 8 },
  { name: "牛奶絨玫瑰雕花沙發墊",           cost: 60,  freightRate: 8 },
];

export const DEFAULT_CUSHION_THICKNESSES = [
  { cm: 0, m35: 85, m45: 110, t35: 100, t45: 120 },
  { cm: 3, m35: 100, m45: 130, t35: 115, t45: 150 },
  { cm: 5, m35: 110, m45: 150, t35: 117, t45: 160 },
  { cm: 8, m35: 140, m45: 200, t35: 156, t45: 223 },
  { cm: 10, m35: 160, m45: 240, t35: 187, t45: 280 },
  { cm: 12, m35: 180, m45: 280, t35: 204, t45: 317 },
  { cm: 15, m35: 210, m45: 330, t35: 242, t45: 380 },
  { cm: 20, m35: 260, m45: 430, t35: 305, t45: 505 },
];

export const DEFAULT_CARPET_STYLES = [
  { name: "圓絨滴膠底",           cost: 60,  freightRate: 25 },
  { name: "圓絨矽膠棉布底",       cost: 70,  freightRate: 25 },
  { name: "仿羊絨滴膠底",         cost: 75,  freightRate: 25 },
  { name: "仿羊絨矽膠棉布底",     cost: 85,  freightRate: 25 },
  { name: "細棉絨矽膠棉布底",     cost: 75,  freightRate: 25 },
  { name: "南非劍麻常規",         cost: 135, freightRate: 25 },
  { name: "南非劍麻魚骨紋",       cost: 171, freightRate: 25 },
  { name: "雙面劍麻",             cost: 265, freightRate: 25 },
  { name: "拉非草",               cost: 248, freightRate: 25 },
  { name: "雙色編織靜奢風地毯",   cost: 130, freightRate: 25 },
  { name: "羊毛地毯-加厚",        cost: 259, freightRate: 25 },
  { name: "羊毛地毯-一般",        cost: 160, freightRate: 25 },
  { name: "手工棉織地毯",         cost: 170, freightRate: 25 },
  { name: "俐落框線羊毛地毯",     cost: 198, freightRate: 25 },
  { name: "天然羊毛緹花雙環編織地毯", cost: 198, freightRate: 25 },
  { name: "天然羊毛手工編織地毯", cost: 268, freightRate: 25 },
];

export const DEFAULT_EDGING_CARPET_STYLES = [
  { name: "尼龍",       cost: 185, freightRate: 36 },
  { name: "波蘿",       cost: 135, freightRate: 36 },
  { name: "鑽石",       cost: 135, freightRate: 36 },
  { name: "尼龍印刷",   cost: 240, freightRate: 36 },
  { name: "波蘿印刷",   cost: 180, freightRate: 36 },
  { name: "鑽石印刷",   cost: 180, freightRate: 36 },
  { name: "尼龍雕刻",   cost: 300, freightRate: 36 },
  { name: "波蘿雕刻",   cost: 260, freightRate: 36 },
  { name: "鑽石雕刻",   cost: 260, freightRate: 36 },
  { name: "尼龍異形",   cost: 185, freightRate: 36 },
  { name: "波蘿異形",   cost: 150, freightRate: 36 },
  { name: "鑽石異形",   cost: 150, freightRate: 36 },
  { name: "椰棕地毯",   cost: 288, freightRate: 52 },
  { name: "椰棕地毯印刷", cost: 350, freightRate: 52, extraCost: 150 },
];

export const DEFAULT_WALL_STICKER_STYLES = [
  { name: "方形PU",           cost: 150, freightRate: 48 },
  { name: "方形棉麻",         cost: 180, freightRate: 48 },
  { name: "方形科技布",       cost: 180, freightRate: 48 },
  { name: "方形油蠟布",       cost: 190, freightRate: 48 },
  { name: "方形科技布皮革",   cost: 180, freightRate: 48 },
  { name: "貓咪星球",         cost: 238, freightRate: 48 },
  { name: "整體規劃多邊形",   cost: 388, freightRate: 48 },
  { name: "圓頭PU",           cost: 170, freightRate: 48 },
  { name: "圓頭棉麻",         cost: 200, freightRate: 48 },
  { name: "圓頭科技布",       cost: 200, freightRate: 48 },
  { name: "圓頭科技布皮革",   cost: 200, freightRate: 48 },
];

export const CUSHION_TYPES = [
  "一般坐墊",
  "科技布坐墊",
  "特殊坐墊",
  "一般靠墊",
  "科技布靠墊",
  "特殊靠墊",
  "單海綿",
  "單布套(棉麻)",
  "單布套(科技布)",
  "一般抱枕套",
  "科技布抱枕套",
  "一般抱枕套+枕心",
  "科技布抱枕套+枕心",
];

export const CUSHION_DENSITIES = ["35D", "45D"];
